<form [formGroup]="form" *ngIf="form">
  <div fxLayout="column" class="ma-1">
    <div
      fxLayout="column"
      fxLayoutAlign="space-between stretch"
      class="full-width"
      fxLayoutGap="7px">
      
      <ng-container *ngIf="formKeys.length;else NoParams">
        <div class="full-width"
          *ngFor="let formKey of formKeys; let i = index">
  
          <mat-form-field class="full-width">
            <mat-label>{{ formLabels[formKey] }}</mat-label>
  
            <input 
              matInput
              [placeholder]="formLabels[formKey]"
              [formControl]="form.get(formKey)"
            />
  
            <mat-error
              [flexFormControlError]="form.get(formKey)"
              *ngIf="!form.get(formKey).valid && form.get(formKey).touched"
            ></mat-error>
          </mat-form-field>
        </div>
      </ng-container>

      <ng-template #NoParams>
        {{ 'sipphone_config_template.message.no_params'|translate }}
      </ng-template>
    </div>
  </div>
</form>
